import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { LuComplainType } from "src/app/models/HR/Lu_ComplainType/lu_complainType.model";
import { environment } from "../../../../environments/environment";
import { ResponseModel } from "../../../models/SharedModels/response.model";
import { GenericRepository } from "../../generic-repository/GenericRepository";
import { IComplainTypeRepository } from "./IComplainTypeRepository";

@Injectable()
export class ComplainTypeRepository extends GenericRepository<LuComplainType> implements IComplainTypeRepository {

    url: string = environment.urlAddress;
    constructor(protected _http: HttpClient) {
        super(_http, 'api/luComplainType', environment.urlAddress);
    }
    GetAll(currentPage: number, recordsPerPage: number): Observable<any> {
        return this.Get('/SelectAll' + '/' + currentPage + '/' + recordsPerPage).pipe(map(this.extractData), catchError(this.handleError));
    }
    SaveRec(item: LuComplainType): Observable<ResponseModel> {
        return this.PostData('/SaveRec', item).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadNavRec(navType: number, currentIndex: number): Observable<ResponseModel> {
        return this.GetById('/NavRec/' + navType + '/' + currentIndex).pipe(map(this.extractData), catchError(this.handleError));
    }
    LoadRec(Id: number): Observable<ResponseModel> {
        return this.GetById('/GetRec/' + Id).pipe(map(this.extractData), catchError(this.handleError));
    }
    DeleteRec(Id: number): Observable<ResponseModel> {
        return this.Delete('/DeleteRec/' + Id).pipe(map(this.extractData), catchError(this.handleError));
    }
}